export var gasSpeedup = function gasSpeedup(value) {
  return value.mul(120).div(100);
};